// 是否是对象
export const isObj = (target: any) => Object.prototype.toString.call(target) === '[object Object]'
